import styled from 'styled-components';
import { Link } from 'gatsby';
import activeClassName from '../activeClassName';

const StyledNavLink = styled(Link).attrs(() => ({ state: { via: 'NavLink' } }))`
  transition: all .2s;
  display: inline-block;
  color: ${({ theme }) => theme.pages.blockNav.linkColor};
  padding: .5rem 1rem;
  text-decoration: none;
  text-transform: uppercase;
  &:hover,
  &.${activeClassName} {
    background-color: ${({ theme }) => theme.pages.blockNav.linkBackgroundColorHover};
    border-radius: .25rem;
    color: ${({ theme }) => theme.pages.blockNav.linkColorHover};
  }
`;

export default StyledNavLink;
